import { SapAssetsAdd } from "@/features"

const SapAssetsAddPage = () => {
  return <SapAssetsAdd />
}

export default SapAssetsAddPage
